import { render, staticRenderFns } from "./SelectCareProtocolDialog.vue?vue&type=template&id=35a54e7e&"
import script from "./SelectCareProtocolDialog.vue?vue&type=script&lang=js&"
export * from "./SelectCareProtocolDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports